<template>
  <b-modal
    v-model="visible"
    :title="form.id ? 'Editar marca de inversor' : 'Agregar marca de inversor'"
    centered
    hide-footer
  >
    <b-form-group label="Nombre de la marca">
      <b-form-input
        v-model="form.brand_name"
        placeholder="Huawei"
        :state="form.brand_name ? null : false"
      ></b-form-input>
      <small class="text-black-60"
        >Debe coincidir con la opción de la pregunta de marca. No distingue
        mayúsculas ni tildes.</small
      >
    </b-form-group>

    <b-form-group label="Opción de la pregunta de marca">
      <b-form-select v-model="form.option" :options="opcionesMarca"></b-form-select>
      <small class="text-black-60"
        >Enlazarla hace que el mapeo siga funcionando aunque se renombre la
        marca.</small
      >
    </b-form-group>

    <b-form-group label="ID de proveedor en la APP Copec (device_provider_id)">
      <b-form-input
        v-model="form.device_provider_id"
        placeholder="384a7bd4-8c2b-4b53-a3eb-95efbaeaee9b"
        :state="uuidValido"
      ></b-form-input>
      <small class="text-black-60">Debe tener el formato de un UUID.</small>
    </b-form-group>

    <b-form-group label="Tipo de identificador que acepta este proveedor">
      <b-form-select
        v-model="form.external_id_type"
        :options="tiposIdentificador"
      ></b-form-select>
      <small class="text-black-60"
        >La APP Copec rechaza el número de serie en algunos proveedores y exige el
        identificador de planta.</small
      >
    </b-form-group>

    <b-form-checkbox v-model="form.enabled" class="mb-3">Activa</b-form-checkbox>

    <div class="d-flex justify-content-end">
      <b-button variant="outline-info-3" class="mr-2" @click="visible = false"
        >Cancelar</b-button
      >
      <b-button variant="primary" :disabled="!formValido" @click="guardar"
        >Guardar</b-button
      >
    </div>
  </b-modal>
</template>

<script>
const UUID_RE =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export default {
  name: "ModalBrandMapping",
  props: {
    brandOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      visible: false,
      form: this.formularioVacio(),
      tiposIdentificador: [
        { value: "SERIAL_NUMBER", text: "Número de serie (SERIAL_NUMBER)" },
        { value: "PLANT_ID", text: "Identificador de planta (PLANT_ID)" },
      ],
    };
  },
  computed: {
    opcionesMarca() {
      return [{ value: null, text: "Sin enlazar" }].concat(
        this.brandOptions.map((o) => ({ value: o.id, text: o.name }))
      );
    },
    uuidValido() {
      if (!this.form.device_provider_id) return false;
      return UUID_RE.test(this.form.device_provider_id.trim());
    },
    formValido() {
      return !!this.form.brand_name && this.uuidValido;
    },
  },
  methods: {
    formularioVacio() {
      return {
        id: null,
        brand_name: "",
        option: null,
        device_provider_id: "",
        external_id_type: "SERIAL_NUMBER",
        enabled: true,
      };
    },
    openModal(mapeo) {
      this.form = mapeo
        ? {
            id: mapeo.id,
            brand_name: mapeo.brand_name,
            option: mapeo.option,
            device_provider_id: mapeo.device_provider_id,
            external_id_type: mapeo.external_id_type,
            enabled: mapeo.enabled,
          }
        : this.formularioVacio();
      this.visible = true;
    },
    guardar() {
      this.$emit("guardar", {
        ...this.form,
        brand_name: this.form.brand_name.trim(),
        device_provider_id: this.form.device_provider_id.trim(),
      });
      this.visible = false;
    },
  },
};
</script>
